export default __webpack_public_path__ + "hero-b5a1324dbff1efc6b6d91710d48653f8.digested.jpg";